<mat-spinner></mat-spinner>
<div>
    <b>Please Wait...</b>
    <p>Redirecting you to the requested page.</p>
</div>
